import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';
import DataGridCell from './DataGridCell';

export function dateTimeCell(params: GridRenderCellParams<any>) {
  let formattedDate = null;
  if (params.value) formattedDate = dayjs(params.value).format('DD/MM/YYYY HH:mm');
  return <DataGridCell content={formattedDate ?? ''} />;
}
